module.exports = __webpack_public_path__ + "static/media/avatar2.0fc2094f.png";